(function($, undefined) {
	'use strict';
	var s = $(window).scrollTop();
	var utils;
	
	function checkSelectedSection() {
		var checkFold = s + (($(window).height() / 3)); /*(($(window).height() / 3) * 2)*/
		var firstVisibleElement = getFirstCompletelyVisibleElement($('.directory__cat_title'));
		var parent = firstVisibleElement.closest('.directory__cat');
		
		if (parent.length == 0) {
			parent = getFirstPartiallyVisibleElement($('.directory__cat'));
		}
		
		
		$('.directory__cat').not(parent).removeClass('selected');
		parent.addClass('selected');
		$('.sidebar__trigger').removeClass('selected');
		$('.sidebar__trigger[data-directory-id=' + parent.attr('data-id') + ']').addClass('selected');
	}
	
	var getFirstCompletelyVisibleElement = function(elements) {
		return elements.filter((i, el) => {
			var elTop = $(el).offset().top;
			var scrollTop = $(window).scrollTop();
			return elTop >= scrollTop && elTop + $(el).outerHeight() <= scrollTop + $(window).height();
		}).first();
	};
	var getFirstPartiallyVisibleElement = function(elements) {
		return elements.filter((i, el) => {
			var elTop = $(el).offset().top;
			var scrollTop = $(window).scrollTop();
			return elTop <= scrollTop + $(window).height() && elTop + $(el).outerHeight() >= scrollTop;
		}).first();
	};

	var updateSidebarTop = function() {
		if ($('.responsive-detector-xs').css('visibility') === 'hidden') {
			utils.updateItemTop(20, $('.sidebar__inner'), $('.sidebar'), $('.directory__inner'));
		}
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		
		if ($('.directory').length > 0) {
			updateSidebarTop();
			$(window).scroll(function() {
				updateSidebarTop();
			});
			$(window).resize(function() {
				updateSidebarTop();
			});
		}

		$('[data-directory-id]').click(function () {
			var t = $(this);
			var id = t.attr('data-directory-id');
			var section = $('.directory__cat[data-id="'+id+'"]');
			var headerH = $('.site-header').outerHeight();
			var target = section.offset().top - headerH;
			
			$('html').scrollTop(target);
		});
		
		if ($('.sidebar').length !== 0 && $('.directory__content').length !== 0) {
			// checkCatDocked();
			checkSelectedSection();
			
			$(window).scroll(function () {
				s = $(window).scrollTop();
				// checkCatDocked();
				checkSelectedSection();
			});
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
